import { JSGraph as OriginalJSGraph, peakPicking as originalPeakPicking, } from 'common-spectrum';
import { xyObjectNormedY } from 'ml-spectra-processing';
import { Spectrum } from 'ms-spectrum';
import { getAnnotations } from "./jsgraph/getAnnotations.js";
export { AnalysesManager, Analysis, toJcamp } from 'common-spectrum';
export { fromText } from "./from/fromText.js";
export { fromJcamp } from "./from/fromJcamp.js";
export function autoPeakPicking(spectrum, options = {}) {
    const data = {
        x: spectrum.variables.x.data,
        y: spectrum.variables.y.data,
    };
    const msSpectrum = new Spectrum(data);
    const peaks = xyObjectNormedY(msSpectrum.getBestPeaks(options).filter((peak) => !peak.close), { value: 100, algorithm: 'max' });
    return peaks.map((peak) => {
        return {
            mass: peak.x,
            intensity: peak.y,
        };
    });
}
export function peakPicking(spectrum, target, options) {
    const peak = originalPeakPicking(spectrum, target, options);
    if (!peak)
        return undefined;
    return {
        mass: peak.x,
        intensity: peak.y,
    };
}
export const JSGraph = { ...OriginalJSGraph, getAnnotations };
//# sourceMappingURL=index.js.map